/* ui.js */
'use strict';
import tippy from 'tippy.js';
import GLightbox from 'glightbox';
import "./extensions/cookie-consent.js";
import "./extensions/search/search-autocomplete.js";
import "./extensions/search/fake-placeholder.js";

tippy('[data-tippy-content]');

const header = document.querySelector('header');

const visibleHeaderPx = () => {
    const r = header.getBoundingClientRect();
    return Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
};

let raf;
const update = () => {
    console.log('update', window.innerWidth);
    if (window.innerWidth - 8 <= 1023.98) {
        // opcjonalnie: reset stylu
        document.querySelectorAll('.purposeMenu, .productsMenu')
            .forEach(el => el.style.marginTop = '');
        return;
    }

    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
        if (!header) return;
        const px = visibleHeaderPx();
        document.querySelectorAll('.purposeMenu, .productsMenu')
            .forEach(el => el.style.marginTop = `${px}px`);
    });
};

update();
window.addEventListener('scroll', update, { passive: true });
window.addEventListener('resize', update, { passive: true });
new MutationObserver(update).observe(document.body, { childList: true, subtree: true });



/* =========================================================================
   Utils
========================================================================= */
const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
const $  = (sel, ctx = document) => ctx.querySelector(sel);
const rafDebounce = (fn, delay = 0) => {
    let raf = 0, t = 0;
    return () => {
        cancelAnimationFrame(raf); clearTimeout(t);
        raf = requestAnimationFrame(() => { t = setTimeout(fn, delay); });
    };
};
const setCssVar = (name, val, node = document.documentElement) =>
    node.style.setProperty(name, val);
const getY = () => window.pageYOffset || document.documentElement.scrollTop || 0;

/* =========================================================================
   1) Breadcrumbs – auto-scroll do końca, gdy jest overflow
========================================================================= */
(() => {
    const el = $('.breadcrumbs');
    if (!el) return;

    const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const behavior = prefersReduced ? 'auto' : 'smooth';
    const isScrollable = (node) => node.scrollWidth > node.clientWidth + 2;
    const scrollToEnd = () => { if (isScrollable(el)) el.scrollTo({ left: el.scrollWidth, behavior }); };

    const schedule = rafDebounce(scrollToEnd, 120);

    // start (po załadowaniu), zmiana fontów/rozmiaru/DOM
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });

    if (document.fonts?.ready) document.fonts.ready.then(schedule);
    new ResizeObserver(schedule).observe(el);
    new MutationObserver(schedule).observe(el, { childList: true, subtree: true, characterData: true });
    window.addEventListener('breadcrumbs:update', schedule);

    // skróty: Ctrl/Cmd + End/Home
    el.addEventListener('keydown', (e) => {
        const mod = e.ctrlKey || e.metaKey;
        if (!mod) return;
        if (e.key === 'End')  { e.preventDefault(); el.scrollTo({ left: el.scrollWidth, behavior: 'smooth' }); }
        if (e.key === 'Home') { e.preventDefault(); el.scrollTo({ left: 0,            behavior: 'smooth' }); }
    });
})();

// breadcrumbs menu
(() => {
    const root = document.querySelector('.breadcrumbs');
    if (!root) return;

    const items = Array.from(root.querySelectorAll('.breadcrumbs__item--has-children'));

    // ===== Helpers: pozycjonowanie panelu przeniesionego do body =====
    const placeFixedPanel = (item) => {
        const btn   = item.querySelector('.breadcrumbs__toggle') || item.querySelector('.breadcrumbs__link');
        const panel = item.__panel || item.querySelector('.breadcrumbs__panel');
        if (!btn || !panel) return;

        const btnRect   = btn.getBoundingClientRect();
        const vpW       = window.innerWidth;
        const vpH       = window.innerHeight;
        const margin    = 8;

        panel.style.maxHeight = Math.max(200, vpH - btnRect.bottom - margin - 8) + 'px';

        // domyślnie pod i wyrównane do lewej krawędzi
        let left = btnRect.left;
        let top  = btnRect.bottom + 4;

        // jeśli wychodzi poza prawą krawędź — dosuń do prawej
        const panelW = Math.min(panel.offsetWidth || 320, vpW - margin * 2);
        if (left + panelW + margin > vpW) {
            left = Math.max(margin, vpW - panelW - margin);
        }
        // jeśli za nisko — spróbuj wyświetlić nad przyciskiem
        const estH = Math.min(panel.scrollHeight || 360, parseFloat(panel.style.maxHeight) || 360);
        if (top + estH + margin > vpH && btnRect.top - estH - 4 > margin) {
            top = Math.max(margin, btnRect.top - estH - 4);
        }

        panel.style.left = Math.round(left) + 'px';
        panel.style.top  = Math.round(top)  + 'px';
    };

    const openPortal = (item) => {
        const panel = item.querySelector('.breadcrumbs__panel');
        if (!panel) return;

        // przenieś do body
        if (!panel.dataset.portal) {
            item.__panelHost = item;
            item.__panel     = panel;
            panel.dataset.portal = 'absolute';
            panel.style.display = 'block';
            document.body.appendChild(panel);
        }

        // ustaw pozycję tylko na otwarciu + przy scrollu X breadcrumbs
        placeFixedPanel(item);

        const reposition = () => placeFixedPanel(item);
        item.__reposition = reposition;

        root.addEventListener('scroll', reposition, { passive: true });

        // USUNIĘTE:
        // window.addEventListener('scroll', reposition, { passive: true });
        // window.addEventListener('resize', reposition);
    };

    const closePortal = (item) => {
        const panel = item.__panel || item.querySelector('.breadcrumbs__panel');
        if (!panel) return;

        if (panel.dataset.portal === 'absolute') {
            panel.removeAttribute('data-portal');
            panel.style.left = panel.style.top = '';
            panel.style.maxHeight = '';
            panel.style.display = 'none';
            (item.__panelHost || item).appendChild(panel);
        }

        if (item.__reposition) {
            root.removeEventListener('scroll', item.__reposition);

            // USUNIĘTE:
            // window.removeEventListener('scroll', item.__reposition);
            // window.removeEventListener('resize', item.__reposition);

            item.__reposition = null;
        }
    };


    const closeAll = (except = null) => {
        items.forEach(it => {
            if (it !== except) {
                it.classList.remove('breadcrumbs__item--open');
                it.removeAttribute('aria-expanded');
                it.querySelector('.breadcrumbs__toggle')?.setAttribute('aria-expanded', 'false');
                closePortal(it);
            }
        });
    };

    const toggleItem = (item, force = null) => {
        const open = force ?? !item.classList.contains('breadcrumbs__item--open');
        if (open) {
            closeAll(item);
            item.classList.add('breadcrumbs__item--open');
            item.setAttribute('aria-expanded', 'true');
            item.querySelector('.breadcrumbs__toggle')?.setAttribute('aria-expanded', 'true');
            // >>> zamiast display w kontenerze – otwórz jako portal
            openPortal(item);

            // focus do panelu
            const first = (item.__panel || item.querySelector('.breadcrumbs__panel'))?.querySelector('.breadcrumbs__option');
            first?.focus({ preventScroll: true });
        } else {
            item.classList.remove('breadcrumbs__item--open');
            item.removeAttribute('aria-expanded');
            item.querySelector('.breadcrumbs__toggle')?.setAttribute('aria-expanded', 'false');
            closePortal(item);
        }
    };

    // === interakcje ===
    root.addEventListener('click', (e) => {
        const btn = e.target.closest('.breadcrumbs__toggle');
        if (!btn) return;
        const item = btn.closest('.breadcrumbs__item--has-children');
        if (!item) return;
        e.preventDefault();
        toggleItem(item);
    });

    document.addEventListener('click', (e) => {
        if (!root.contains(e.target) && !e.target.closest('.breadcrumbs__panel[data-portal="fixed"]')) {
            closeAll();
        }
    });

    root.addEventListener('keydown', (e) => {
        const openItem = root.querySelector('.breadcrumbs__item--open');
        if (!openItem) return;

        const panel = openItem.__panel || openItem.querySelector('.breadcrumbs__panel');
        const options = Array.from(panel?.querySelectorAll('.breadcrumbs__option') || []);
        const idx = options.indexOf(document.activeElement);

        if (e.key === 'Escape') {
            toggleItem(openItem, false);
            openItem.querySelector('.breadcrumbs__toggle')?.focus();
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            (options[Math.min(options.length - 1, Math.max(0, idx + 1))] || options[0])?.focus();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            (options[Math.max(0, idx - 1)] || options[options.length - 1])?.focus();
        }
    });

    items.forEach(item => {
        const btn = item.querySelector('.breadcrumbs__toggle');
        btn?.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleItem(item, true);
            }
        });
    });
})();

// purpose + product menu
document.addEventListener('DOMContentLoaded', () => {
    const body      = document.body;
    const triggers  = document.querySelectorAll('[data-mega-trigger]');
    const panelsMap = new Map();

    const isDesktop = () => window.matchMedia('(min-width: 1025px)').matches;

    const html = document.documentElement;
    let lockedScrollY = 0;

    const lockScroll = () => {
        lockedScrollY = window.scrollY;

        const keepPosition = () => {
            if (window.scrollY !== lockedScrollY) {
                window.scrollTo(0, lockedScrollY);
            }
        };

        // zapisujemy, żeby móc usunąć później
        html._keepPosition = keepPosition;

        window.addEventListener('scroll', keepPosition);
        window.addEventListener('wheel', preventDefault, { passive: false });
        window.addEventListener('touchmove', preventDefault, { passive: false });
    };

    const unlockScroll = () => {
        if (html._keepPosition) {
            window.removeEventListener('scroll', html._keepPosition);
            html._keepPosition = null;
        }
        window.removeEventListener('wheel', preventDefault, { passive: false });
        window.removeEventListener('touchmove', preventDefault, { passive: false });
    };

    function preventDefault(e) {
        e.preventDefault();
    }


    // Zbieramy panele do mapy: "purpose" -> element, "products" -> element
    document.querySelectorAll('[data-mega-panel]').forEach(panel => {
        const name = panel.dataset.megaPanel;
        if (name) panelsMap.set(name, panel);
    });

    let openName = null;
    const ANIM_DURATION = 300; // już nieużywany, zostawiony do ewentualnego CSS

    const getTrigger = (name) =>
        document.querySelector(`[data-mega-trigger="${name}"]`);

    const setItemActive = (trigger, isActive) => {
        const item = trigger?.closest('.navigation__item');
        if (item) item.classList.toggle('is-active', isActive);
    };

    const clearAllActive = () => {
        document.querySelectorAll('.navigation__item.is-active')
            .forEach(item => item.classList.remove('is-active'));
    };

    const closeCurrent = () => {
        if (!openName) return;

        const name    = openName;
        const panel   = panelsMap.get(name);
        const trigger = getTrigger(name);

        if (!panel || !trigger) {
            openName = null;
            unlockScroll();
            clearAllActive();
            return;
        }

        panel.classList.add('hidden');

        trigger.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        setItemActive(trigger, false);

        unlockScroll();
        openName = null;
    };

    const openPanel = (name) => {
        const panel   = panelsMap.get(name);
        const trigger = getTrigger(name);

        if (!panel || !trigger) return;

        // jeśli inne menu otwarte — zamknij
        if (openName && openName !== name) closeCurrent();

        // kliknięcie w to samo — zamyka
        if (openName === name) {
            closeCurrent();
            return;
        }

        panel.classList.remove('hidden');

        if (isDesktop() && name !== 'homeowner') lockScroll();

        trigger.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        setItemActive(trigger, true);

        openName = name;
    };

    // Obsługa kliknięć w triggery
    triggers.forEach(trigger => {
        const name = trigger.dataset.megaTrigger;
        if (!name) return;

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (openName === name) closeCurrent();
            else openPanel(name);
        });
    });

    // Klik poza panelem / triggerami – zamyka otwarte menu
    document.addEventListener('click', (e) => {
        if (!openName) return;

        const panel   = panelsMap.get(openName);
        const trigger = getTrigger(openName);
        if (!panel || !trigger) {
            closeCurrent();
            return;
        }

        const clickInsidePanel = panel.contains(e.target);
        const clickOnTrigger   = trigger.contains(e.target);

        if (!clickInsidePanel && !clickOnTrigger) closeCurrent();
    });

    // ESC zamyka aktualne menu
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeCurrent();
    });
});



/* =========================================================================
   2) „Kropka” online/offline wg godzin pracy
      – zielona: pn–pt, 08:00–15:59 (16:00 już czerwony)
      – czerwona: weekend i poza godzinami
      HTML:
        <span class="status-dot" data-online-dot
              data-open="08:00" data-close="16:00" data-timezone="Europe/Warsaw"></span>
========================================================================= */
(() => {
    const dots = $$('[data-online-dot]');
    if (!dots.length) return;

    const DEFAULTS = { open: '08:00', close: '16:00', timeZone: 'Europe/Warsaw' };
    const LABELS   = { online: 'Czat online', offline: 'Poza godzinami pracy' };

    const parseHM = (str) => {
        const m = /^(\d{1,2}):(\d{2})$/.exec(str || '');
        if (!m) return { h: 0, m: 0 };
        return { h: Math.min(23, +m[1]), m: Math.min(59, +m[2]) };
    };

    // Cache formatterów per strefa dla wydajności
    const fmtCache = new Map();
    const getFormatters = (timeZone) => {
        if (fmtCache.has(timeZone)) return fmtCache.get(timeZone);
        const hm = new Intl.DateTimeFormat('en-GB', { timeZone, hour: '2-digit', minute: '2-digit', hour12: false });
        const wd = new Intl.DateTimeFormat('en-GB', { timeZone, weekday: 'short' });
        const f = { hm, wd };
        fmtCache.set(timeZone, f);
        return f;
    };

    const getLocalParts = (date, timeZone) => {
        const { hm, wd } = getFormatters(timeZone);
        const parts = hm.formatToParts(date);
        const h = +parts.find(p => p.type === 'hour').value;
        const m = +parts.find(p => p.type === 'minute').value;
        return { h, m, wd: wd.format(date) }; // Mon..Sun
    };

    const isWeekday = (wd) => wd !== 'Sat' && wd !== 'Sun';
    const inRange = (h, m, from, to) => {
        const afterOpen   = h > from.h || (h === from.h && m >= from.m);
        const beforeClose = h < to.h   || (h === to.h   && m <  to.m);
        return afterOpen && beforeClose; // [open, close)
    };

    const readCfg = (el) => ({
        open:     el.getAttribute('data-open')     || DEFAULTS.open,
        close:    el.getAttribute('data-close')    || DEFAULTS.close,
        timeZone: el.getAttribute('data-timezone') || DEFAULTS.timeZone,
    });

    const computeState = (now, cfg) => {
        const { h, m, wd } = getLocalParts(now, cfg.timeZone);
        if (!isWeekday(wd)) return false;
        const o = parseHM(cfg.open);
        const c = parseHM(cfg.close);
        // jeżeli open == close -> traktuj jako zamknięte (edge-case)
        if (o.h === c.h && o.m === c.m) return false;
        return inRange(h, m, o, c);
    };

    const setDot = (el, online) => {
        el.classList.toggle('is-online',  online);
        el.classList.toggle('is-offline', !online);
        el.dataset.state = online ? 'online' : 'offline';
        const label = online ? LABELS.online : LABELS.offline;
        el.setAttribute('aria-label', label);
        el.setAttribute('title', label);
    };

    const updateAll = () => {
        const now = new Date();
        dots.forEach(el => setDot(el, computeState(now, readCfg(el))));
    };

    updateAll();
    const t = setInterval(updateAll, 60_000);
    window.addEventListener('officehours:refresh', updateAll);
    window.addEventListener('visibilitychange', () => { if (!document.hidden) updateAll(); });
    window.addEventListener('beforeunload', () => clearInterval(t));
})();

// menu filtrów
// ========================================
// MENU FILTRÓW (delegacja)
// ========================================

(() => {

    function getElements() {

        return {
            filtersToggle: document.querySelector('.button__filters'),
            catalogWrapper: document.querySelector('.catalog__menu'),
            catalogMenus: document.querySelectorAll('.catalog-menu'),
            body: document.body,
        };
    }

    function updateToggleText(isOpen) {

        const filtersToggle = document.querySelector('.button__filters');

        if (!filtersToggle) return;

        const openTitle =
            filtersToggle.dataset.openTitle || 'Otwórz menu';

        const closeTitle =
            filtersToggle.dataset.closeTitle || 'Zamknij menu';

        filtersToggle.textContent = isOpen
            ? closeTitle
            : openTitle;
    }

    function openFilters() {

        const {
            filtersToggle,
            catalogWrapper,
            catalogMenus,
            body
        } = getElements();

        if (!catalogWrapper) return;

        catalogWrapper.classList.add('is-visible');

        catalogMenus.forEach(menu => {
            menu.classList.add('is-visible');
        });

        updateToggleText(true);
        body.style.overflow = 'hidden';
    }

    function closeFilters() {

        const {
            filtersToggle,
            catalogWrapper,
            catalogMenus,
            body
        } = getElements();

        if (!catalogWrapper) return;

        catalogWrapper.classList.remove('is-visible');

        catalogMenus.forEach(menu => {
            menu.classList.remove('is-visible');
        });

        updateToggleText(false);

        body.style.overflow = '';
    }

    /**
     * 🔘 OPEN / CLOSE BUTTON
     */
    document.addEventListener('click', (e) => {

        const toggle = e.target.closest('.button__filters');

        if (!toggle) return;

        const wrapper = document.querySelector('.catalog__menu');

        if (!wrapper) return;

        const isVisible = wrapper.classList.contains('is-visible');

        isVisible
            ? closeFilters()
            : openFilters();
    });

    /**
     * ❌ CLOSE BUTTON
     */
    document.addEventListener('click', (e) => {

        const closeBtn =
            e.target.closest('.catalog-menu__mobile-header .close');

        if (!closeBtn) return;

        closeFilters();
    });

    /**
     * ⌨️ ENTER / SPACE
     */
    document.addEventListener('keydown', (e) => {

        const closeBtn =
            e.target.closest('.catalog-menu__mobile-header .close');

        if (!closeBtn) return;

        if (e.key === 'Enter' || e.key === ' ') {

            e.preventDefault();

            closeFilters();
        }
    });

    /**
     * 🧠 OVERLAY CLICK
     */
    document.addEventListener('click', (e) => {

        const wrapper = document.querySelector('.catalog__menu');

        if (!wrapper) return;

        if (!wrapper.classList.contains('is-visible')) return;

        const clickedInsideMenu = e.target.closest('.catalog-menu');

        if (!clickedInsideMenu && !e.target.closest('.button__filters')) {
            closeFilters();
        }
    });

    /**
     * ⌨️ ESC
     */
    document.addEventListener('keydown', (e) => {

        if (e.key === 'Escape') {
            closeFilters();
        }
    });

})();

// hamburger menu
document.addEventListener("DOMContentLoaded", () => {
    const hamburger = document.querySelector(".mast__hamburger");
    const navigation = document.querySelector(".navigation");

    hamburger.addEventListener("click", () => {
        hamburger.classList.toggle("is-active");
        navigation.classList.toggle("is-visible");
    });
});

// language menu
// document.addEventListener("DOMContentLoaded", () => {
//     const body = document.querySelector('body');
//     // const languageButton = document.querySelector(".mast__language-button");
//     // const languageList = document.querySelector(".mast__language-list");
//     // const languageClose = document.querySelector(".mast__language-close");
//
//     // languageButton.addEventListener("click", () => {
//     //     languageList.classList.toggle("is-visible");
//     //     body.classList.toggle("disabled");
//     // })
//     //
//     // languageClose.addEventListener("click", () => {
//     //     languageList.classList.toggle("is-visible");
//     //     body.classList.toggle("disabled");
//     // })
//
// });

// searchbox
document.addEventListener("DOMContentLoaded", () => {
    const searchButton = document.querySelector(".mast__search-button");
    const searchForm = document.querySelector(".mast__search");

    searchButton.addEventListener("click", () => {
        searchForm.classList.toggle("is-visible");
    })
});

// gLightbox - youtube

function normalizeYouTubeLinks() {
    document.querySelectorAll('a.glightbox[href*="youtube.com/watch"]').forEach(a => {
        try {
            const u = new URL(a.href);
            const id = u.searchParams.get('v');
            if (!id) return;
            a.href = `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1&playsinline=1`;
            a.dataset.type = 'video';
            a.dataset.source = 'youtube';
            a.dataset.width = '1280';
            a.dataset.height = '720';
        } catch (_) {}
    });
}

document.addEventListener('DOMContentLoaded', () => {
    normalizeYouTubeLinks();

    const lb = GLightbox({
        selector: '.glightbox',
        autoplayVideos: false,        // klik = start, brak konfliktu z polityką autoplay
        touchNavigation: true,
        keyboardNavigation: true,
        closeOnOutsideClick: true,
        openEffect: 'zoom',
        closeEffect: 'zoom',
    });
});

(() => {
    // 1) Wrap text in <span> + add empty data-tippy-content
    const enhanceSelectTrigger = (root = document) => {
        root.querySelectorAll('.c-select__trigger').forEach(btn => {
            const textNode = Array.from(btn.childNodes)
                .find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());

            if (!textNode) return;

            let span = btn.querySelector('span');

            // jeśli span już istnieje – upewnij się, że ma attr
            if (span) {
                if (!span.hasAttribute('data-tippy-content')) {
                    span.setAttribute('data-tippy-content', '');
                }
                return;
            }

            // create span
            span = document.createElement('span');
            span.textContent = textNode.textContent.trim();
            span.setAttribute('data-tippy-content', '');

            textNode.textContent = '';
            btn.prepend(span);
        });
    };

    // 2) Observe dynamic DOM
    const observer = new MutationObserver(mutations => {
        for (const m of mutations) {
            for (const node of m.addedNodes) {
                if (node.nodeType !== 1) continue;

                if (node.matches?.('.c-select__trigger')) {
                    enhanceSelectTrigger(node.parentNode);
                } else if (node.querySelector?.('.c-select__trigger')) {
                    enhanceSelectTrigger(node);
                }
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // 3) Init tippy (delegation – works with dynamic elements)
    const initTippy = () => {
        if (!window.tippy || typeof window.tippy.delegate !== 'function') {
            // wait until tippy is available
            setTimeout(initTippy, 50);
            return;
        }

        window.tippy.delegate('body', {
            target: '[data-tippy-content]',
            content(reference) {
                // np. tekst spana
                return reference.textContent.trim();
            },
            placement: 'top',
            appendTo: document.body
        });
    };

    // bootstrap
    enhanceSelectTrigger(document);
    initTippy();
})();

// GA Events
import {kliknalMenuDolne} from "./ga-events/kliknal-menu-dolne.js"
import {kliknalMenuGorne} from "./ga-events/kliknal-menu-gorne.js"
import {kliknalPrzekierowanieDoKonfiguratora} from "./ga-events/kliknal-przekierowanie-do-konfiguratora.js"

kliknalMenuDolne();
kliknalMenuGorne();
kliknalPrzekierowanieDoKonfiguratora();
